import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function SelectComp({ nameItem, valueItem, arrayItems, onChangeFunc, labelName }) {
  const { t } = useTranslation();
  const [array, setArray] = useState();
  const [name, setName] = useState();
  const [valueSelect, setValueSelect] = useState(nameItem == 'page' ? 1 : '');

  useEffect(() => {
    setArray(arrayItems);
    setName(nameItem);
  }, [arrayItems, nameItem]);

  const handleChange = event => {
    setValueSelect(event.target.value);
    onChangeFunc(event);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="search-label">{t(labelName)}</InputLabel>
      <Select labelId="search-label" id="search-label" value={valueSelect} label={t(labelName)} onChange={handleChange}>
        {array &&
          array.map((item, i) => {
            return (
              <MenuItem key={i} value={item}>
                {item}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
}

export default SelectComp;
